__turbopack_context__.v({
  "hero": "Hero-module-scss-module__WOdYDW__hero",
  "media": "Hero-module-scss-module__WOdYDW__media",
});
